export const IDRcoverpayBranchCodeOptionsCard = [
    {
        value: "PERMATA",
        label: "BANK PERMATA",
    },
    {
        value: "PERMATA_SYARIAH",
        label: "BANK PERMATA SYARIAH",
    },
    {
        value: "BANGKOK",
        label: "BANK BANGKOK",
    },
    {
        value: "ACEH_SYARIAH",
        label: "BANK ACEH SYARIAH",
    },
    {
        value: "AGRIS",
        label: "BANK AGRIS (BANK IBK INDONESIA)",
    },
    {
        value: "PRIMA_MASTER",
        label: "BANK PRIMA MASTER",
    },
    {
        value: "QNB_INDONESIA",
        label: "BANK QNB INDONESIA",
    },
    {
        value: "BPD_SULAWESI_TENGGARA",
        label: "BANK BPD SULAWESI TENGGARA",
    },
    {
        value: "BPD_SULAWESI_UTARA",
        label: "BANK BPD SULAWESI UTARA (BANK SULUTGO)",
    },
    {
        value: "BPD_SUMATERA_BARAT",
        label: "BANK BPD SUMATERA BARAT (BANK NAGARI)",
    },
    {
        value: "BPD_SUMATERA_BARAT_SYARIAH",
        label: "BANK BPD SUMATERA BARAT SYARIAH",
    },
    {
        value: "BPD_SUMATERA_SELATAN_BABEL",
        label: "BANK BPD SUMATERA SELATAN BABEL",
    },
    {
        value: "BPD_SUMATERA_SELATAN_SYARIAH",
        label: "BANK BPD SUMATERA SELATAN SYARIAH",
    },
    {
        value: "BPD_YOGYAKARTA",
        label: "BANK BPD YOGYAKARTA",
    },
    {
        value: "BPD_YOGYAKARTA_SYARIAH",
        label: "BANK BPD YOGYAKARTA SYARIAH",
    },
    {
        value: "BTN_SYARIAH",
        label: "BANK BTN SYARIAH",
    },
    {
        value: "CIMB_SYARIAH",
        label: "BANK CIMB NIAGA SYARIAH",
    },
    {
        value: "CITIBANK",
        label: "BANK CITIBANK",
    },
    {
        value: "COMMONWEALTH",
        label: "BANK COMMONWEALTH (Bank Arta Niaga Kencana)",
    },
    {
        value: "DANAMON_SYARIAH",
        label: "BANK DANAMON SYARIAH",
    },
    {
        value: "DBS_INDONESIA",
        label: "BANK DBS INDONESIA",
    },
    {
        value: "DEUTSCHE_AG",
        label: "BANK DEUTSCHE AG",
    },
    {
        value: "PANIN",
        label: "BANK PAN INDONESIA /PANIN",
    },
    {
        value: "PANIN_SYARIAH",
        label: "BANK PANIN SYARIAH",
    },
    {
        value: "AMAR_INDONESIA",
        label: "BANK AMAR INDONESIA (ANGLOMAS INTERNATIONAL BANK)",
    },
    {
        value: "ANZ_INDONESIA",
        label: "BANK ANZ INDONESIA",
    },
    {
        value: "ARTHA_GRAHA",
        label: "BANK ARTHA GRAHA",
    },
    {
        value: "ARTOS_INDONESIA",
        label: "BANK ARTOS INDONESIA (Bank Jago - BJG)",
    },
    {
        value: "BCA_SYARIAH",
        label: "BANK BCA SYARIAH",
    },
    {
        value: "BISNIS_INTERNASIONAL",
        label: "BANK BISNIS INTERNASIONAL",
    },
    {
        value: "BNI",
        label: "BANK BNI",
    },
    {
        value: "BTPN_SYARIAH",
        label: "BANK BTPN SYARIAH",
    },
    {
        value: "BUKOPIN",
        label: "BANK BUKOPIN",
    },
    {
        value: "BUMI_ARTA",
        label: "BANK BUMI ARTA",
    },
    {
        value: "CAPITAL_INDONESIA",
        label: "BANK CAPITAL INDONESIA",
    },
    {
        value: "BCA",
        label: "BANK BCA",
    },
    {
        value: "CENTRATAMA",
        label: "BANK CENTRATAMA",
    },
    {
        value: "CHINA_CONSTRUCTION_INDONESIA",
        label: "BANK CHINA CONSTRUCTION INDONESIA (BANK ANTAR DAERAH - CCB)",
    },
    {
        value: "CTBC_INDONESIA",
        label: "BANK CTBC INDONESIA",
    },
    {
        value: "DANAMON",
        label: "BANK DANAMON",
    },
    {
        value: "KESEJAHTERAAN",
        label: "BANK KESEJAHTERAAN (SEABANK)",
    },
    {
        value: "MANDIRI",
        label: "BANK MANDIRI",
    },
    {
        value: "MASPION_INDONESIA",
        label: "BANK MASPION INDONESIA",
    },
    {
        value: "MAYAPADA",
        label: "BANK MAYAPADA",
    },
    {
        value: "MAYBANK",
        label: "BANK MAYBANK INDONESIA",
    },
    {
        value: "MAYBANK_UUS",
        label: "BANK MAYBANK INDONESIA UUS",
    },
    {
        value: "MAYBANK_SYARIAH",
        label: "BANK MAYBANK SYARIAH INDONESIA",
    },
    {
        value: "MAYORA",
        label: "BANK MAYORA",
    },
    {
        value: "MEGA_SYARIAH",
        label: "BANK MEGA SYARIAH",
    },
    {
        value: "MEGA",
        label: "BANK MEGA TBK.",
    },
    {
        value: "MESTIKA_DHARMA",
        label: "BANK MESTIKA DHARMA",
    },
    {
        value: "SHINHAN_INDONESIA",
        label: "BANK SHINHAN INDONESIA",
    },
    {
        value: "MITRANIAGA",
        label: "BANK MITRANIAGA",
    },
    {
        value: "MIZUHO_INDONESIA",
        label: "BANK MIZUHO INDONESIA",
    },
    {
        value: "MNC_INTERNATIONAL",
        label: "BANK MNC INTERNATIONAL",
    },
    {
        value: "MUAMALAT",
        label: "BANK MUAMALAT",
    },
    {
        value: "MULTI_ARTA_SENTOSA",
        label: "BANK MULTI ARTA SENTOSA",
    },
    {
        value: "JTRUST_INDONESIA",
        label: "BANK JTRUST INDONESIA (BANK MUTIARA)",
    },
    {
        value: "NUSANTARA",
        label: "BANK NUSANTARA",
    },
    {
        value: "OCBC_NISP",
        label: "BANK OCBC NISP",
    },
    {
        value: "OCBC_NISP_SYARIAH",
        label: "BANK OCBC NISP SYARIAH",
    },
    {
        value: "OF_AMERICA",
        label: "BANK OF AMERICA (Bank of America Merill-Lynch - BAML)",
    },
    {
        value: "OF_CHINA",
        label: "BANK OF CHINA",
    },
    {
        value: "OF_INDIA_INDONESIA",
        label: "BANK OF INDIA INDONESIA",
    },
    {
        value: "PIKKO",
        label: "BANK PIKKO",
    },
    {
        value: "OKE_INDONESIA",
        label: "BANK OKE INDONESIA (BANK DINAR | ANDARA)",
    },
    {
        value: "BPD_NTT",
        label: "BANK BPD NTT",
    },
    {
        value: "DKI",
        label: "BANK DKI",
    },
    {
        value: "DKI_SYARIAH",
        label: "BANK DKI SYARIAH",
    },
    {
        value: "FAMA",
        label: "BANK FAMA",
    },
    {
        value: "GANESHA",
        label: "BANK GANESHA",
    },
    {
        value: "HARDA_INTERNASIONAL",
        label: "BANK HARDA INTERNASIONAL (ALLO BANK INDONESIA)",
    },
    {
        value: "HARMONI_INTERNATIONAL",
        label: "BANK HARMONI INTERNATIONAL",
    },
    {
        value: "HSBC_INDONESIA",
        label: "BANK HSBC INDONESIA",
    },
    {
        value: "ICBC_INDONESIA",
        label: "BANK ICBC INDONESIA",
    },
    {
        value: "INA_PERDANA",
        label: "BANK INA PERDANA",
    },
    {
        value: "INDEX_SELINDO",
        label: "BANK INDEX SELINDO",
    },
    {
        value: "JABAR",
        label: "BANK JABAR BANTEN (BANK JAWA BARAT - BJB)",
    },
    {
        value: "JABAR_SYARIAH",
        label: "BANK JABAR BANTEN SYARIAH (BJB SYARIAH)",
    },
    {
        value: "JASA_JAKARTA",
        label: "BANK JASA JAKARTA",
    },
    {
        value: "JATIM",
        label: "BANK JATIM",
    },
    {
        value: "JATIM_SYARIAH",
        label: "BANK JATIM SYARIAH",
    },
    {
        value: "KEB_HANA",
        label: "BANK KEB HANA",
    },
    {
        value: "BRI",
        label: "BANK BRI",
    },
    {
        value: "BRI_AGRONIAGA",
        label: "BANK BRI AGRONIAGA",
    },
    {
        value: "ROYAL_INDONESIA",
        label: "BANK ROYAL INDONESIA (Bank Digital BCA - BLU)",
    },
    {
        value: "SAHABAT_SAMPOERNA",
        label: "BANK SAHABAT SAMPOERNA",
    },
    {
        value: "SBI_INDONESIA",
        label: "BANK SBI INDONESIA",
    },
    {
        value: "SINARMAS",
        label: "BANK SINARMAS",
    },
    {
        value: "SYARIAH_BRI",
        label: "BANK SYARIAH BRI",
    },
    {
        value: "SYARIAH_BUKOPIN",
        label: "BANK SYARIAH BUKOPIN",
    },
    {
        value: "SYARIAH_MANDIRI",
        label: "BANK SYARIAH MANDIRI (BANK SYARIAH INDONESIA - BSI)",
    },
    {
        value: "BTN",

        label: "BANK BTN",
    },
    {
        value: "UOB",
        label: "BANK UOB INDONESIA",
    },
    {
        value: "VICTORIA_INTERNATIONAL",
        label: "BANK VICTORIA INTERNATIONAL",
    },
    {
        value: "VICTORIA_SYARIAH",
        label: "BANK VICTORIA SYARIAH",
    },
    {
        value: "WOORI_SAUDARA_INDONESIA",
        label: "BANK WOORI SAUDARA INDONESIA 1906 (Bank Woori Indonesia)",
    },
    {
        value: "YUDHA_BAKTI",
        label: "BANK YUDHA BAKTI (Bank Neo Commerce - BNC)",
    },
    {
        value: "BNI_SYARIAH",
        label: "BANK BNI SYARIAH",
    },
    {
        value: "BNP_PARIBAS_INDONESIA",
        label: "BANK BNP PARIBAS INDONESIA",
    },
    {
        value: "BPD_BALI",
        label: "BANK BPD BALI",
    },
    {
        value: "BPD_BANTEN",
        label: "BANK BPD BANTEN",
    },
    {
        value: "BPD_BENGKULU",
        label: "BANK BPD BENGKULU",
    },
    {
        value: "BPD_JAMBI",
        label: "BANK BPD JAMBI",
    },
    {
        value: "BPD_JAWA_TENGAH",
        label: "BANK BPD JAWA TENGAH (BANK JATENG)",
    },
    {
        value: "BPD_KALBAR",
        label: "BANK BPD KALBAR",
    },
    {
        value: "BPD_KALBAR_SYARIAH",
        label: "BANK BPD KALBAR SYARIAH",
    },
    {
        value: "BPD_KALTIM",
        label: "BANK BPD KALTIM (BANK KALTIMTARA)",
    },
    {
        value: "BPD_KALTIM_SYARIAH",
        label: "BANK BPD KALTIM SYARIAH",
    },
    {
        value: "BPD_KALSEL",
        label: "BANK BPD KALSEL",
    },
    {
        value: "BPD_PAPUA",
        label: "BANK BPD PAPUA",
    },
    {
        value: "BPD_RIAU_KEPRI",
        label: "BANK BPD RIAU KEPRI",
    },
    {
        value: "BPD_KALSEL_SYARIAH",
        label: "BANK BPD KALSEL SYARIAH",
    },
    {
        value: "BPD_KALTENG",
        label: "BANK BPD KALTENG",
    },
    {
        value: "BPD_LAMPUNG",
        label: "BANK BPD LAMPUNG",
    },
    {
        value: "BPD_MALUKU",
        label: "BANK BPD MALUKU",
    },
    {
        value: "BPD_NTB",
        label: "BANK BPD NTB",
    },
    {
        value: "BPD_SULAWESI_TENGAH",
        label: "BANK BPD SULAWESI TENGAH",
    },
    {
        value: "BPD_SUMATERA_UTARA",
        label: "BANK BPD SUMATERA UTARA",
    },
    {
        value: "BPD_SUMUT_UNIT_SYARIAH",
        label: "BANK BPD SUMUT UNIT SYARIAH",
    },
    {
        value: "BTPN",
        label: "BANK BTPN (SUMITOMO MITSUI INDONESIA)",
    },
    {
        value: "CIMB",
        label: "BANK CIMB NIAGA",
    },
    {
        value: "MUFG_LTD",
        label: "BANK MUFG LTD (BANK TOKYO MITSUBISHI UFJ)",
    },
    {
        value: "NOBU_NATIONAL",
        label: "BANK NOBU NATIONAL",
    },
    {
        value: "SULSELBAR",
        label: "BANK SULSELBAR (PT Bank Pembangunan Daerah Sulawesi Selatan dan Sulawesi Barat)",
    },
    {
        value: "INTERIM",
        label: "BANK INTERIM INDONESIA (BANK RABO)",
    },
    {
        value: "RESONA_PERDANIA",
        label: "BANK RESONA PERDANIA",
    },
    {
        value: "STANDARD_CHARTERED",
        label: "BANK STANDARD CHARTERED",
    },
    {
        value: "MANDIRI_TASPEN",
        label: "BANK MANDIRI TASPEN",
    },
    {
        value: "JP_MORGAN",
        label: "BANK JP MORGAN",
    },
    {
        value: "BPD_JATENG_UUS",
        label: "BANK BPD JATENG UUS",
    },
    {
        value: "NTB_SYARIAH",
        label: "BANK NTB SYARIAH",
    },
    {
        value: "BSI",
        label: "BANK SYARIAH INDONESIA",
    },
    {
        value: "ALADIN_SYARIAH",
        label: "BANK ALADIN SYARIAH",
    },
];

export const IDRcoverpayBranchCodeOptionsEWallet = [
    {
        value: "OVO",
        label: "OVO",
    },
    {
        value: "DANA",
        label: "DANA",
    },
    {
        value: "GOPAY",
        label: "GOPAY",
    },
    {
        value: "SHOPEEPAY",
        label: "SHOPEEPAY",
    },
    {
        value: "LINKAJA",
        label: "LINKAJA",
    },
];
